export default __webpack_public_path__ + "static/media/anotharug.a1a95405.jpg";